





































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  ADMIN_SIDEBAR_MENU,
  ADMIN_SIDEBAR_OPTIONS,
} from "@/resources/constants/sidebarMenu";

@Component({
  name: "admin-sidebar-component",
})
export default class SidebarComponent extends Vue {
  active = ADMIN_SIDEBAR_OPTIONS.SPACE;
  ADMIN_SIDEBAR_MENU = ADMIN_SIDEBAR_MENU;
  constructor() {
    super();
  }
  mounted() {
    const route = this.$route.name;
    const optionMenu = ADMIN_SIDEBAR_MENU.filter((a) => a.link === route);
    if (optionMenu.length <= 0) {
      this.$router.push({ name: "spaces_list" });
    }
    this.active =
      optionMenu.length > 0 ? optionMenu[0].id : ADMIN_SIDEBAR_OPTIONS.SPACE;
  }
  isHawkings(): boolean {
    if (window.location.host.includes("hawkings.education")) return true;
    else return false;
  }
  logOut() {
    this.$store.dispatch("AuthStore/logOutAction");
  }
  @Watch("active")
  goTo() {
    const item = ADMIN_SIDEBAR_MENU.filter((a) => a.id === this.active)[0];
    const route = this.$route.name;
    if (route !== item.link) this.$router.push({ name: item.link });
  }
}
